module.exports = __webpack_public_path__ + "static/media/face.5c528171.png";